import React from 'react'
import SuccessPage from '../success'

const SuccessPageEn = () => {
    return <SuccessPage languageCode="en" />
}

export default SuccessPageEn
